module.exports = __webpack_public_path__ + "img/st-cb6-y1.e2054d6e.gif";